import React from 'react';
import { InputLabel, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  labelRoot: {
    marginBottom: 8,
    color: '#1D1D1D',
  },
  labelAstrix: {
    color: '#FE0053',
  },
}));
const BuzzLabel = ({ id = Math.random(), required = false, label = '' }) => {
  const styles = useStyles();
  if (label)
    return (
      <InputLabel
        required={required}
        htmlFor={id}
        classes={{ root: styles.labelRoot, asterisk: styles.labelAstrix }}>
        {label}
      </InputLabel>
    );

  return null;
};

export default BuzzLabel;
